import type { TableWrapperProps } from '../types';

import { Card, CardContent, CardHeader } from '@/components/ui/card';

import { cn } from '@/lib/utils';

export const TableWrapper = (props: TableWrapperProps) => {
  const { title, recordsTotal = 0, headerActions, children, className } = props;

  const displayTitle =
    typeof title === 'function' ? title(recordsTotal) : title;

  return (
    <Card className={cn('px-2', className)}>
      {(displayTitle || headerActions) && (
        <CardHeader className="px-2">
          <div className="flex items-center justify-between">
            {displayTitle && (
              <h1 className="text-lg font-semibold sm:text-2xl">
                {displayTitle}
              </h1>
            )}
            {headerActions && (
              <div className="flex items-center gap-3">{headerActions}</div>
            )}
          </div>
        </CardHeader>
      )}
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  );
};
